import React, { useCallback, useState } from "react";
import PatientAuthorizationsSection from "./authorizations/PatientAuthorizationsSection";
import PatientAuthorizationDocumentsSection from "./authorizations/PatientAuthorizationDocumentsSection";
import PatientScheduleSection from "./schedule/PatientScheduleSection";

const PatientAuthScheduleTab = ({
  patient,
  chartId,
  canEdit,
  canDelete = false,
  onSaved,
  episodeMeta,
  evalTabEnabled = true,
}) => {
  const [scheduleReloadKey, setScheduleReloadKey] = useState(0);

  const handleSaved = useCallback(
    async (opts) => {
      await onSaved?.(opts);
      setScheduleReloadKey((n) => n + 1);
    },
    [onSaved],
  );

  return (
    <div className="flex flex-col gap-3">
      <PatientAuthorizationDocumentsSection
        patientId={patient?.id}
        chartId={chartId}
        canEdit={canEdit}
        onRefresh={handleSaved}
      />
      <PatientAuthorizationsSection
        patient={patient}
        chartId={chartId}
        canEdit={canEdit}
        onSaved={handleSaved}
      />
      <PatientScheduleSection
        patientId={patient?.id}
        patient={patient}
        episodeMeta={episodeMeta}
        canEdit={canEdit}
        canDelete={canDelete}
        evalTabEnabled={evalTabEnabled}
        reloadKey={scheduleReloadKey}
      />
    </div>
  );
};

export default PatientAuthScheduleTab;
